export type StatusOption = {
  name: string;
  code: string;
  primary_color: string;
  secondary_color: string | null;
};

export enum StatusKey {
  NOT_STARTED = "Not Started",
  IN_PROGRESS = "In Progress",
  NOT_NEEDED = "Not Needed",
  COMPLETED = "Completed",
  OVERDUE = "Overdue",
  FLAGGED = "Flagged",
}

export const STATUS: Record<string, StatusOption> = Object.freeze({
  "Not Started": {
    name: "Not Started",
    code: "not-started",
    primary_color: "#757575",
    secondary_color: null,
  },
  "In Progress": {
    name: "In Progress",
    code: "in-progress",
    primary_color: "#326FD1",
    secondary_color: null,
  },
  Completed: {
    name: "Completed",
    code: "completed",
    primary_color: "#188A42",
    secondary_color: null,
  },
  Overdue: {
    name: "Overdue",
    code: "overdue",
    primary_color: "#EAB308",
    secondary_color: null,
  },
  Flagged: {
    name: "Flagged",
    code: "flagged",
    primary_color: "#FF3D32",
    secondary_color: null,
  },
  "Not Needed": {
    name: "Not Needed",
    code: "not-needed",
    primary_color: "#9E9E9E",
    secondary_color: null,
  },
});

export function getStatusOptions(keys: StatusKey[]): StatusOption[] {
  return keys
    .map((key) => STATUS[key])
    .filter((item): item is StatusOption => !!item);
}
